import styled from 'styled-components';
import { Box } from '@material-ui/core';
import { theme } from '../utils/theme';

export const DataToolbar = styled(Box)(props => ({
  paddingTop: theme(props).spacing(2.625),
  paddingBottom: theme(props).spacing(2.625),
  paddingLeft:theme(props).spacing(4),
  paddingRight: theme(props).spacing(4),
  display: 'flex',
  height: theme(props).spacing(6.5),
  boxSizing: 'content-box',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
})) as typeof Box;

export const DataToolbarPart = styled(Box)(props => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
})) as typeof Box;